module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid11_800x647.a4fb2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid11_800x647.jpg
// module id = cyUV
// module chunks = 0